var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-row",
        { staticStyle: { "margin-bottom": "20px" } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-arrow-down" },
                  on: {
                    click: function ($event) {
                      return _vm.toggleRowExpansion(!_vm.expansion)
                    },
                  },
                },
                [_vm._v("展开/折叠\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: ["resource:add"],
                      expression: "['resource:add']",
                    },
                  ],
                  attrs: { icon: "el-icon-plus", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.addResource()
                    },
                  },
                },
                [_vm._v("添加\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("table-page", {
        ref: "tablePage",
        attrs: {
          url: _vm.tableUrl,
          "row-key": "id",
          "page-ing-type": false,
          "check-box": false,
          columns: _vm.columns,
        },
        scopedSlots: _vm._u([
          {
            key: "type",
            fn: function (ref) {
              var row = ref.row
              return [
                row.type === "1"
                  ? _c("el-tag", { attrs: { type: "primary" } }, [
                      _vm._v("目录"),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                row.type === "2"
                  ? _c("el-tag", { attrs: { type: "warning" } }, [
                      _vm._v("菜单"),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                row.type === "3"
                  ? _c("el-tag", { attrs: { type: "info" } }, [_vm._v("按钮")])
                  : _vm._e(),
              ]
            },
          },
          {
            key: "resStatus",
            fn: function (ref) {
              var row = ref.row
              return [
                row.resStatus === "0"
                  ? _c("el-tag", { attrs: { type: "success" } }, [
                      _vm._v("正常"),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                row.resStatus === "1"
                  ? _c("el-tag", { attrs: { type: "error" } }, [_vm._v("禁用")])
                  : _vm._e(),
              ]
            },
          },
          {
            key: "action",
            fn: function (ref) {
              var row = ref.row
              return [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: ["resource:update"],
                        expression: "['resource:update']",
                      },
                    ],
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.update(row)
                      },
                    },
                  },
                  [_vm._v("修改")]
                ),
                _vm._v(" "),
                row.children === null || row.children.length === 0
                  ? _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["resource:delete"],
                            expression: "['resource:delete']",
                          },
                        ],
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.remove(row)
                          },
                        },
                      },
                      [_vm._v("删除\n      ")]
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _vm.dialogShow
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.dialogTitle,
                visible: _vm.dialogShow,
                "close-on-click-modal": false,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogShow = $event
                },
                close: function ($event) {
                  return _vm.handleReset("form")
                },
              },
            },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "菜单类型", prop: "type" },
                              on: {
                                input: function ($event) {
                                  return _vm.change($event)
                                },
                              },
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.form.type,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "type", $$v)
                                    },
                                    expression: "form.type",
                                  },
                                },
                                [
                                  _vm._l(
                                    _vm.resourceTypeOptionList,
                                    function (item) {
                                      return [
                                        _c(
                                          "el-radio-button",
                                          { attrs: { label: item.dictValue } },
                                          [_vm._v(_vm._s(item.dictLabel))]
                                        ),
                                      ]
                                    }
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "标题", prop: "title" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入标题" },
                                on: {
                                  input: function ($event) {
                                    return _vm.change($event)
                                  },
                                },
                                model: {
                                  value: _vm.form.title,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "title", $$v)
                                  },
                                  expression: "form.title",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "上级类目", prop: "parentId" } },
                            [
                              _c("vue-treeselect", {
                                attrs: {
                                  options: _vm.menuList,
                                  placeholder: "请选择上级类目",
                                  normalizer: _vm.normalizer,
                                },
                                on: { select: _vm.treeSelect },
                                model: {
                                  value: _vm.form.parentId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "parentId", $$v)
                                  },
                                  expression: "form.parentId",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "排序", prop: "resSort" } },
                            [
                              _c("el-input-number", {
                                attrs: {
                                  placeholder: "请输入排序",
                                  precision: 2,
                                  step: 0.1,
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.change($event)
                                  },
                                },
                                model: {
                                  value: _vm.form.resSort,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "resSort", $$v)
                                  },
                                  expression: "form.resSort",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.form.menuExtFlag === "2" || _vm.form.type === "3"
                    ? _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "权限标识",
                                    prop: "permission",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入权限标识" },
                                    on: {
                                      input: function ($event) {
                                        return _vm.change($event)
                                      },
                                    },
                                    model: {
                                      value: _vm.form.permission,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "permission", $$v)
                                      },
                                      expression: "form.permission",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "后端url路径地址",
                                    prop: "resPath",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入后端url路径地址",
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.change($event)
                                      },
                                    },
                                    model: {
                                      value: _vm.form.resPath,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "resPath", $$v)
                                      },
                                      expression: "form.resPath",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "请求方式", prop: "httpMethod" },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: "请输入请求方式",
                                    clearable: "",
                                    disabled: _vm.form.menuExtFlag === "1",
                                  },
                                  model: {
                                    value: _vm.form.httpMethod,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "httpMethod", $$v)
                                    },
                                    expression: "form.httpMethod",
                                  },
                                },
                                [
                                  _vm._l(
                                    _vm.httpMethodOptionList,
                                    function (item) {
                                      return [
                                        _c("el-option", {
                                          attrs: {
                                            value: item.dictValue,
                                            label: item.dictLabel,
                                          },
                                        }),
                                      ]
                                    }
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "状态", prop: "resStatus" } },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.form.resStatus,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "resStatus", $$v)
                                    },
                                    expression: "form.resStatus",
                                  },
                                },
                                [
                                  _vm._l(_vm.statusOptionList, function (item) {
                                    return [
                                      _c(
                                        "el-radio",
                                        { attrs: { label: item.dictValue } },
                                        [_vm._v(_vm._s(item.dictLabel))]
                                      ),
                                    ]
                                  }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.form.type === "1" || _vm.form.type === "2"
                    ? _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "外链菜单",
                                    prop: "menuExtFlag",
                                  },
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      on: {
                                        input: function ($event) {
                                          return _vm.change($event)
                                        },
                                        change: _vm.changeExtFlag,
                                      },
                                      model: {
                                        value: _vm.form.menuExtFlag,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "menuExtFlag", $$v)
                                        },
                                        expression: "form.menuExtFlag",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-radio-button",
                                        { attrs: { label: "1" } },
                                        [_vm._v("是")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-radio-button",
                                        { attrs: { label: "2" } },
                                        [_vm._v("否")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "菜单缓存",
                                    prop: "menuCacheFlag",
                                  },
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      on: {
                                        input: function ($event) {
                                          return _vm.change($event)
                                        },
                                      },
                                      model: {
                                        value: _vm.form.menuCacheFlag,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "menuCacheFlag",
                                            $$v
                                          )
                                        },
                                        expression: "form.menuCacheFlag",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-radio-button",
                                        { attrs: { label: "1" } },
                                        [_vm._v("是")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-radio-button",
                                        { attrs: { label: "2" } },
                                        [_vm._v("否")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  (_vm.form.type === "1" || _vm.form.type === "2") &&
                  _vm.form.menuExtFlag === "2"
                    ? _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "菜单组件名称",
                                    prop: "componentName",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入菜单组件名称",
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.change($event)
                                      },
                                    },
                                    model: {
                                      value: _vm.form.componentName,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "componentName", $$v)
                                      },
                                      expression: "form.componentName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "菜单组件地址",
                                    prop: "componentPath",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入菜单组件地址",
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.change($event)
                                      },
                                    },
                                    model: {
                                      value: _vm.form.componentPath,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "componentPath", $$v)
                                      },
                                      expression: "form.componentPath",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.form.type === "1" || _vm.form.type === "2"
                    ? _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "菜单和目录可见",
                                    prop: "menuHiddenFlag",
                                  },
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      on: {
                                        input: function ($event) {
                                          return _vm.change($event)
                                        },
                                      },
                                      model: {
                                        value: _vm.form.menuHiddenFlag,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "menuHiddenFlag",
                                            $$v
                                          )
                                        },
                                        expression: "form.menuHiddenFlag",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-radio-button",
                                        { attrs: { label: "1" } },
                                        [_vm._v("是")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-radio-button",
                                        { attrs: { label: "2" } },
                                        [_vm._v("否")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "菜单图标",
                                    prop: "menuIcon",
                                  },
                                },
                                [
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        placement: "bottom-start",
                                        width: "350",
                                        trigger: "click",
                                      },
                                      on: {
                                        show: function ($event) {
                                          return _vm.$refs["iconSelect"].reset()
                                        },
                                      },
                                    },
                                    [
                                      _c("IconSelect", {
                                        ref: "iconSelect",
                                        on: { selected: _vm.iconSelected },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "el-input",
                                        {
                                          attrs: {
                                            slot: "reference",
                                            placeholder: "点击选择图标",
                                            readonly: "",
                                          },
                                          slot: "reference",
                                          model: {
                                            value: _vm.form.menuIcon,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "menuIcon",
                                                $$v
                                              )
                                            },
                                            expression: "form.menuIcon",
                                          },
                                        },
                                        [
                                          _vm.form.menuIcon
                                            ? _c("svg-icon", {
                                                staticClass: "el-input__icon",
                                                attrs: {
                                                  slot: "prefix",
                                                  "icon-class":
                                                    _vm.form.menuIcon,
                                                },
                                                slot: "prefix",
                                              })
                                            : _c("i", {
                                                staticClass:
                                                  "el-icon-search el-input__icon",
                                                attrs: { slot: "prefix" },
                                                slot: "prefix",
                                              }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.form.type === "1" || _vm.form.type === "2"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "路由地址", prop: "routePath" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入路由地址" },
                            on: {
                              input: function ($event) {
                                return _vm.change($event)
                              },
                            },
                            model: {
                              value: _vm.form.routePath,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "routePath", $$v)
                              },
                              expression: "form.routePath",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.handleReset("form")
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmit("form")
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }